(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tangent-product-highlights"] && !Shopify.designMode) return;
  try {
    
(function () {
  const CONFIG = {
    targetSelector: ".product-custom-field__content",
    apiUrl: window.TANGENT_CONTEXT
      ? `https://service.tangent.ai/shopify/get-product-highlights?shop_id=${window.TANGENT_CONTEXT.shopId}&product_id=${window.TANGENT_CONTEXT.productId}${window.TANGENT_CONTEXT.quizTags}`
      : "",

    charSpeed: 16,
    headingToParagraphDelay: 600,
    nextHeadingDelay: 1000,
  };

  const target = document.querySelector(CONFIG.targetSelector);
  if (!target) return;

  let activeTimers = [];
  let runId = 0;
  let sourceHtml = "";

  function clearTimers() {
    activeTimers.forEach(clearTimeout);
    activeTimers = [];
    runId++;
  }

  function createAccordion() {
    const details = document.createElement("details");

    details.className = "accordion group product-highlights";
    details.setAttribute("is", "accordion-disclosure");
    details.setAttribute("aria-expanded", "false");

    details.innerHTML = `
      <summary>
        <span class="accordion__toggle text-lg">
          <span class="text-with-icon gap-4"><strong>Highlights for you</strong></span>
          <span class="animated-plus group-expanded:rotate" aria-hidden="true"></span>
        </span>
      </summary>

      <div class="accordion__content">
        <div class="prose"></div>
      </div>
    `;

    target.appendChild(details);
    return details;
  }

  function removeAccordion(details) {
    clearTimers();
    if (details && details.parentNode) details.parentNode.removeChild(details);
  }

  function parseBlocks(html) {
    const template = document.createElement("template");
    template.innerHTML = html.trim();

    return Array.from(template.content.children).filter(function (node) {
      return node.nodeType === Node.ELEMENT_NODE && node.textContent.trim();
    });
  }

  function cloneEmptyElement(node) {
    const clone = document.createElement(node.tagName.toLowerCase());

    Array.from(node.attributes).forEach(function (attr) {
      clone.setAttribute(attr.name, attr.value);
    });

    return clone;
  }

  function sleep(ms, currentRunId) {
    return new Promise(function (resolve) {
      const timer = setTimeout(function () {
        resolve(runId === currentRunId);
      }, ms);

      activeTimers.push(timer);
    });
  }

  async function typeNode(sourceNode, targetNode, cursor, currentRunId) {
    for (const child of sourceNode.childNodes) {
      if (runId !== currentRunId) return;

      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent || "";

        for (const char of text) {
          if (runId !== currentRunId) return;

          cursor.remove();
          targetNode.append(document.createTextNode(char));
          targetNode.append(cursor);

          const stillActive = await sleep(CONFIG.charSpeed, currentRunId);
          if (!stillActive) return;
        }
      }

      if (child.nodeType === Node.ELEMENT_NODE) {
        const tagName = child.tagName.toLowerCase();

        if (tagName === "br") {
          cursor.remove();
          targetNode.appendChild(document.createElement("br"));
          targetNode.append(cursor);
          continue;
        }

        const emptyChild = cloneEmptyElement(child);

        cursor.remove();
        targetNode.appendChild(emptyChild);
        emptyChild.append(cursor);

        await typeNode(child, emptyChild, cursor, currentRunId);

        cursor.remove();
        targetNode.append(cursor);
      }
    }
  }

  async function typeBlock(sourceBlock, targetBlock, currentRunId) {
    if (runId !== currentRunId) return;

    const cursor = document.createElement("span");
    cursor.className = "type-cursor";
    cursor.textContent = "|";

    targetBlock.append(cursor);

    await typeNode(sourceBlock, targetBlock, cursor, currentRunId);

    cursor.remove();
  }

  function renderEmptyBlocks(prose, blocks) {
    prose.innerHTML = "";

    return blocks.map(function (block) {
      const emptyBlock = cloneEmptyElement(block);
      prose.appendChild(emptyBlock);
      return emptyBlock;
    });
  }

  function startAnimation(details) {
    clearTimers();

    const currentRunId = runId;
    const prose = details.querySelector(".prose");
    if (!prose) return;

    const blocks = parseBlocks(sourceHtml);
    const renderedBlocks = renderEmptyBlocks(prose, blocks);

    blocks.forEach(function (block, index) {
      const pairIndex = Math.floor(index / 2);
      const isParagraph = index % 2 === 1;

      const delay =
        pairIndex * CONFIG.nextHeadingDelay +
        (isParagraph ? CONFIG.headingToParagraphDelay : 0);

      const timer = setTimeout(function () {
        if (runId === currentRunId && details.open) {
          typeBlock(block, renderedBlocks[index], currentRunId);
        }
      }, delay);

      activeTimers.push(timer);
    });
  }

  async function hydrateFromApi(details) {
    if (!CONFIG.apiUrl) return;

    try {
      const response = await fetch(CONFIG.apiUrl);
      if (!response.ok) throw new Error();

      const data = await response.json();
      const highlights = data?.highlights;

      if (!highlights || !highlights.length) {
        removeAccordion(details);
        return;
      }

      const html = highlights
        .map(function (item) {
          const title = item.title || "";
          const text = item.text || "";

          return `
            <p><strong>${title}</strong></p>
            <p>${text}</p>
          `;
        })
        .join("");

      sourceHtml = html;

      if (details.open) {
        startAnimation(details);
      }
    } catch (error) {
      removeAccordion(details);
    }
  }

  const details = createAccordion();

  details.addEventListener("toggle", function () {
    details.setAttribute("aria-expanded", details.open ? "true" : "false");

    if (details.open) {
      startAnimation(details);
    } else {
      clearTimers();

      const prose = details.querySelector(".prose");
      if (prose) prose.innerHTML = "";
    }
  });

  hydrateFromApi(details);
})();

  } catch(e) { console.error(e); }
})();
})();
